import React from 'react';
import ReactApexChart from 'react-apexcharts';

export default class ApexChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: [...props.data],
            options: {
                chart: {
                    type: 'donut',
                    toolbar: {
                        show: false,
                    },
                },
                colors: [...props.colors],
                labels: [...props.label],
                legend: {
                    position: 'bottom',
                },
                width: 300,
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 240,
                            },
                            legend: {
                                position: 'bottom',
                            },
                        },
                    },
                ],
            },
        };
    }

    render() {
        return (
            <div id="chart3">
                <ReactApexChart options={this.state.options} series={this.state.series} type="donut" />
            </div>
        );
    }
}
